import { render, staticRenderFns } from "./NumBox.vue?vue&type=template&id=be6f0656&scoped=true&"
import script from "./NumBox.vue?vue&type=script&lang=js&"
export * from "./NumBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6f0656",
  null
  
)

export default component.exports